<a [href]="url" class="signup-link" title="{{ action }} with Facebook">
  <img
    src="/assets/images/facebook_logo.svg"
    alt="{{ action }} with Facebook"
  />
</a>
